import { useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { Auth } from 'aws-amplify';
import { decodeJWT } from 'src/utils';

/**
 * Gets cognito:groups from JWT token.
 * Cognito GetUser API does NOT return groups - they're only in the ID/access token.
 * Tries ID token first (groups usually there), then access token, then cookie fallback.
 */
const getCognitoGroupsFromSession = async () => {
  let token = null;

  try {
    const session = await Auth.currentSession();
    const idToken = session?.idToken || session?.getIdToken?.();
    const accessToken = session?.accessToken || session?.getAccessToken?.();

    token =
      idToken?.jwtToken ||
      idToken?.getJwtToken?.() ||
      accessToken?.jwtToken ||
      accessToken?.getJwtToken?.();
  } catch {
    token = Cookies.get('at');
  }

  if (!token) return [];

  const decoded = decodeJWT(token);
  const groups = decoded?.['cognito:groups'];

  if (Array.isArray(groups)) return groups;
  if (typeof groups === 'string') return groups.split(',').map((g) => g.trim());
  return [];
};

const useCognitoGroups = () => {
  const { data: groups = [] } = useQuery({
    queryKey: ['cognito-groups'],
    queryFn: getCognitoGroupsFromSession,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return groups;
};

export default useCognitoGroups;
